import { BaseError } from './base';

type InvalidStorageSetParams = {
  key: string;
  value: string;
};

export class InvalidStorageSet extends BaseError {
  constructor({ key, value }: InvalidStorageSetParams) {
    super({
      cause: null,
      code: 'invalid_storage_set',
      docsUrl: null,
      metaMessages: [`key: ${key}`, value],
      name: 'InvalidStorageSet',
      shortMessage: 'Tried to store a value that does not match the schema',
    });
  }
}
